/*
(function($){
    'use strict';

    $('.dataTable').DataTable( {
        'order':         [],
        'columnDefs':    [{'targets': 'no-sort','orderable': false}],
        'bLengthChange': false,
        'bFilter':       true,
        //'bStateSave': true, //can be turned off
        initComplete:    function () {
            this.api().columns('.filterColumn').every( function () {
                var column = this;
                var $myLabel = $('<label />');

                var select = $('<select class="styled" id="' 
                    + column.header().innerText 
                    + '"><option value="">' + column.header().innerText + '</option></select>')
                    .prependTo( $('.tableFilters') )
                    .on( 'change', function () {
                        var val = $.fn.dataTable.util.escapeRegex(
                            $(this).val()
                        );

                        column
                            .search( val ? '^'+val+'$' : '', true, false )
                            .draw();
                    } );

                // Label 
                $myLabel
                    .attr('for',select.attr('id'))
                    .addClass('visuallyhidden')
                    .html(select.attr('id'))
                    .insertBefore(select); 

                    column.data().unique().sort().each( function (d, j) {
                        d = ($(d).data('val') === undefined) ? d : $(d).data('val');

                        if(column.search() === '^'+d+'$'){
                            select.append( '<option value="'+d+'" selected="selected">'+d+'</option>' );
                        } else {
                            select.append( '<option value="'+d+'">'+d+'</option>' );
                        }
                    } );

            } );
        }
    } );



    
}(jQuery));
*/